<main class="api-key-reveal-page">
    <section class="api-key-reveal-panel" aria-labelledby="apiKeyRevealTitle">
        <header class="panel-header">
            <div class="brand-lockup">
                <img src="assets/logo.png" alt="Kartorium" class="logo">
                <div>
                    <h1 id="apiKeyRevealTitle">Reveal API Key</h1>
                    <p class="text-muted mb-0">One-time access for a trusted integration.</p>
                </div>
            </div>

            <div *ngIf="currentUser$ | async as currentUser" class="profile-chip" aria-label="Signed-in user">
                <img *ngIf="currentUser.picture" [src]="currentUser.picture" [alt]="currentUser.name || currentUser.email || 'Signed-in user'" class="profile-photo">
                <span *ngIf="!currentUser.picture" class="profile-initials" aria-hidden="true">{{ getInitials(currentUser) }}</span>
                <span class="profile-text">
                    <span class="profile-name">{{ currentUser.name || currentUser.email }}</span>
                    <span class="profile-email" *ngIf="currentUser.email">{{ currentUser.email }}</span>
                </span>
            </div>
        </header>

        <div class="panel-body" aria-live="polite">
            <div *ngIf="state === 'loading'" class="state-row">
                <div class="spinner-border spinner-border-sm text-secondary" role="status" aria-label="Loading"></div>
                <span>{{ loadingMessage }}</span>
            </div>

            <ng-container *ngIf="state !== 'loading'">
                <div class="status-banner" [class.error]="state === 'error'" [class.warning]="state === 'ready'" [class.success]="state === 'revealed'">
                    <i class="fas" [class.fa-circle-check]="state === 'revealed'" [class.fa-triangle-exclamation]="state === 'error'" [class.fa-shield-halved]="state === 'ready'"></i>
                    <div>
                        <div class="status-title">{{ state === 'revealed' ? 'API key revealed' : getStatusSummary() }}</div>
                        <div class="status-copy" *ngIf="state === 'ready'">Confirm the recipient and expiration before revealing the key.</div>
                        <div class="status-copy" *ngIf="state === 'error'">{{ errorMessage }}</div>
                        <div class="status-copy" *ngIf="state === 'revealed'">Copy the key now. Kartorium will not show it again.</div>
                    </div>
                </div>

                <dl class="delivery-grid" *ngIf="apiKey">
                    <div>
                        <dt>Key label</dt>
                        <dd>{{ apiKey.label }}</dd>
                    </div>
                    <div>
                        <dt>Recipient</dt>
                        <dd>
                            <span>{{ getRecipientLabel() }}</span>
                            <small *ngIf="getRecipientSubtext()">{{ getRecipientSubtext() }}</small>
                        </dd>
                    </div>
                    <div>
                        <dt>Reveal link expires</dt>
                        <dd>{{ apiKey.delivery_expires_at ? (apiKey.delivery_expires_at | date:'medium') : 'Not available' }}</dd>
                    </div>
                    <div>
                        <dt>API key expires</dt>
                        <dd>{{ apiKey.expires_at ? (apiKey.expires_at | date:'medium') : 'No expiration' }}</dd>
                    </div>
                    <div>
                        <dt>Organization</dt>
                        <dd>{{ apiKey.organization_id }}</dd>
                    </div>
                    <div class="delivery-grid-wide">
                        <dt>Scopes</dt>
                        <dd>{{ getApiKeyScopesLabel() }}</dd>
                    </div>
                    <div>
                        <dt>Delivery ID</dt>
                        <dd><code>{{ keyId }}</code></dd>
                    </div>
                </dl>

                <div *ngIf="state === 'ready'" class="action-row">
                    <button type="button" class="btn btn-primary" (click)="reveal()" [disabled]="state === 'revealing'">
                        <i class="fas fa-key me-2"></i>
                        Reveal Key
                    </button>
                    <a routerLink="/projects" class="btn btn-outline-secondary">
                        Cancel
                    </a>
                </div>

                <div *ngIf="state === 'revealing'" class="state-row">
                    <div class="spinner-border spinner-border-sm text-secondary" role="status" aria-label="Revealing"></div>
                    <span>Revealing key...</span>
                </div>

                <div *ngIf="state === 'revealed' && apiKeySecret" class="revealed-section">
                    <div class="secret-block">
                        <div class="secret-header">
                            <span class="small fw-semibold">API key</span>
                            <button type="button" class="btn btn-sm btn-outline-dark" (click)="copy(apiKeySecret)" aria-label="Copy API key">
                                <i class="fas fa-copy me-1"></i>
                                Copy
                            </button>
                        </div>
                        <code>{{ apiKeySecret }}</code>
                    </div>

                    <div class="secret-block mt-3">
                        <div class="secret-header">
                            <span class="small fw-semibold">Browser test URL</span>
                            <button type="button" class="btn btn-sm btn-outline-dark" (click)="copy(browserTestUrl)" aria-label="Copy browser test URL">
                                <i class="fas fa-copy me-1"></i>
                                Copy
                            </button>
                        </div>
                        <code>{{ browserTestUrl }}</code>
                    </div>

                    <div *ngIf="copied" class="text-success small mt-3">Copied.</div>
                    <div *ngIf="copyError" class="text-danger small mt-3">{{ copyError }}</div>
                </div>

                <div *ngIf="state === 'error'" class="action-row">
                    <button *ngIf="needsSignIn" type="button" class="btn btn-primary" (click)="signInAgain()">
                        Sign In Again
                    </button>
                    <button *ngIf="!needsSignIn" type="button" class="btn btn-outline-primary" (click)="loadDeliveryStatus()">
                        Check Again
                    </button>
                    <a routerLink="/projects" class="btn btn-outline-secondary">
                        Back to Projects
                    </a>
                </div>
            </ng-container>
        </div>
    </section>
</main>
